import { SET_PROMOTIONS } from './../actions/dataForState/setPromotionsToState';
import { UPDATE_PROMOTIONS, SAVING_PROMOTIONS, SAVED_PROMOTIONS } from '../actions/dataForState/updatePromotions';

export const promotions = (state = {}, action) => {
    switch(action.type) {
        case SET_PROMOTIONS: {
            return action.payload;
        }
        case UPDATE_PROMOTIONS: {
            return action.payload;
            /*const { promotions } = action.payload;
            return { ...state, promotions };*/
        }
        default:
            return state;
    }
}

export const isSavingPromotions = (state = {}, action) => {
    switch(action.type) {
        case SAVING_PROMOTIONS: {
            return action.payload;
        }
        default:
            return state;
    }
}

export const isSavedPromotions = (state = {}, action) => {
    switch(action.type) {
        case SAVED_PROMOTIONS: {
            return action.payload;
        }
        default:
            return state;
    }
}